import { GoogleMap } from '@react-google-maps/api';
import { FC, useCallback, useMemo, useState } from 'react';
import { mapService } from '@/editor/components/googleMaps/google-map-service';
import { useInitializeCircles } from '@/editor/components/googleMaps/useInitializeCircles';
import { useRestoreCircles } from '@/editor/components/googleMaps/useRestoreCircles';
import { useDetectPlatformActive } from '@/editor/components/googleMaps/useDetectPlatformActive';

export const MapContainer: FC = () => {
  const center = useMemo(() => ({ lat: 59.9131016, lng: 10.7390799 }), []);
  const mapOptions = useMemo(() => ({ disableDefaultUI: true, zoomControl: true }), []);
  const [mapLoaded, setMapLoaded] = useState(false);

  const onLoad = useCallback((map: google.maps.Map) => {
    mapService.setMap(map);
    console.log('Map has started loading');
  }, []);

  const onIdle = useCallback(() => {
    console.log('Map has fully loaded and is idle now');
    setMapLoaded(true);
  }, []);

  const { initialized, onUnmount } = useInitializeCircles(mapLoaded);
  useRestoreCircles(initialized, mapLoaded);
  useDetectPlatformActive();

  return (
    <>
      <GoogleMap
        mapContainerStyle={{ width: '100%', height: '100%' }}
        center={center}
        zoom={7}
        options={mapOptions}
        onLoad={(map) => onLoad(map)}
        onIdle={onIdle}
        onUnmount={onUnmount}
      />
    </>
  );
};
